import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Grid, Button, IconButton, Typography, Divider, units } from '@ha/dsl';
import { CloseBold } from '@ha/icons';
import { useIntl } from 'ha/i18n';
import LocationFilter from 'ha/components/Filters/LocationFilter';
import { useSearchBarContext } from 'ha/modules/SearchBar/SearchBarContext';

import { SearchFiltersContext } from '../SearchFiltersContext';

const useStyles = makeStyles(theme => ({
  buttonClose: {
    fontSize: units.rem(1),
    position: 'absolute',
    right: theme.spacing(1),
  },
  divider: {
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  buttonApply: {
    marginTop: theme.spacing(2),
  },
}));

interface Props {
  onClose: () => void;
}

const SearchBar: React.FC<Props> = ({ onClose }) => {
  const classes = useStyles();
  const { T } = useIntl();

  const {
    localState,
    onChangePlace,
    onChangeRadius,
    onChangeSearchAreaFilter,
    applyFilters,
  } = React.useContext(SearchFiltersContext);
  const { initialSuggestions } = useSearchBarContext();

  const handleApply = React.useCallback(() => {
    applyFilters();
    onClose();
  }, [applyFilters, onClose]);

  return (
    <React.Fragment>
      <Grid container alignItems="center" justify="space-between">
        <Typography.ParagraphTitle>
          {T('search.filters.location.title')}
        </Typography.ParagraphTitle>
        <IconButton onClick={onClose} className={classes.buttonClose}>
          <CloseBold fontSize="inherit" />
        </IconButton>
      </Grid>
      <Divider className={classes.divider} />
      <LocationFilter
        placeProps={{
          value: localState.place,
          onChange: onChangePlace,
          initialItems: initialSuggestions,
        }}
        searchAreaProps={{
          value: localState.searchArea,
          onChange: onChangeSearchAreaFilter,
          location: 'filter',
        }}
        radiusProps={{
          value: localState.radius,
          onChange: onChangeRadius,
        }}
      />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleApply}
        className={classes.buttonApply}
      >
        {T('cta.apply')}
      </Button>
    </React.Fragment>
  );
};

export default SearchBar;
